<template>
    <div
        v-loading="tagsInUpdate"
        class="user-portfolio-tags"
    >
        <div class="user-portfolio-tags__title">
            <div>Чем выделяется этот участник?</div>
            <div
                v-if="hasAdminAccess && !isMobile"
                class="user-portfolio-tags__history-button"
                @click="historyPopupOpen = true"
            >
                <span>История изменений</span>
                <span class="user-portfolio-tags__history-button-icon">
                    <PencilIcon />
                </span>
            </div>
        </div>

        <div
            v-if="activeTags.length"
            class="user-portfolio-tags__list"
        >
            <PortfolioUserTagItem
                v-for="item in activeTags"
                :key="item.id"
                :catalog-item="item"
                selected
                @click="removeTag"
            />
        </div>

        <div
            v-if="inactiveTags.length"
            class="user-portfolio-tags-available"
        >
            <div
                class="user-portfolio-tags-available__title"
                :class="{
                    'user-portfolio-tags-available__title--opened': availableOpened,
                }"
                @click="toggleAvailable"
            >
                {{ availableOpened ? 'Скрыть характеристики' : 'Показать характеристики' }}
            </div>
            <div
                class="user-portfolio-tags__list user-portfolio-tags-available__list"
                :class="{
                    'user-portfolio-tags-available__list--opened': availableOpened,
                }"
            >
                <PortfolioUserTagItem
                    v-for="item in inactiveTags"
                    :key="item.id"
                    class="user-portfolio-tags-available__item"
                    :catalog-item="item"
                    @click="setTag"
                />
            </div>
        </div>

        <div
            v-if="hasAdminAccess && isMobile"
            class="user-portfolio-tags__history-button"
            @click="historyPopupOpen = true"
        >
            <span>История изменений</span>
            <span class="user-portfolio-tags__history-button-icon">
                    <PencilIcon />
                </span>
        </div>

        <PortfoliUserTagsModal :opened="historyPopupOpen" @close="historyPopupOpen = false" />
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import PortfolioUserTagItem from "@/components/portfolio/tags/PortfolioUserTagItem.vue";
import PortfoliUserTagsModal from "@/components/portfolio/tags/PortfoliUserTagsModal.vue";
import PencilIcon from "@/components/UI/icons/PencilIcon.vue";

export default {
    name: 'PortfolioUserTags',
    components: {
        PencilIcon,
        PortfoliUserTagsModal,
        PortfolioUserTagItem,
    },

    data: () => ({
        availableOpened: false,
        tagsInUpdate: false,
        historyPopupOpen: false,
    }),

    async created() {
        await this.loadRegistryItems({ type: 'user_tags', withMeta: true });
    },

    computed: {
        ...mapGetters([
            'isMobile',
        ]),
        ...mapGetters('data', [
            'getRegistryItems',
        ]),
        ...mapGetters('newUsers', [
            'getUser',
        ]),
        ...mapGetters('auth', [
            'hasAdminAccess',
        ]),

        activeTagIDs() {
            return this.getUser.foreignTagsId;
        },

        activeTags() {
            return this.tagsList.filter(item => this.activeTagIDs.indexOf(item.id) > -1);
        },

        inactiveTags() {
            return this.tagsList.filter(item => this.activeTagIDs.indexOf(item.id) === -1);
        },

        tagsList() {
            return this.getRegistryItems('user_tags');
        },
    },

    methods: {
        ...mapActions('newUsers', [
            'updateUserTags',
            'loadFullUserById',
        ]),
        ...mapActions('data', [
            'loadRegistryItems',
        ]),

        toggleAvailable() {
            this.availableOpened = !this.availableOpened;
        },

        async removeTag(item) {
            const id = item.id;
            const tags = [...this.activeTagIDs];
            const index = tags.indexOf(id);

            if (index === -1) {
                return;
            }

            tags.splice(index, 1);

            await this.updateTags(tags);
        },

        async setTag(item) {
            const id = item.id;
            const tags = [...this.activeTagIDs];

            if (tags.indexOf(id) > -1) {
                return;
            }

            tags.push(id);

            await this.updateTags(tags);
        },

        async updateTags(foreignTagsId) {
            this.tagsInUpdate = true;

            const userId = this.getUser.userId;

            await this.updateUserTags({ userId, foreignTagsId });
            await this.loadFullUserById(userId),

            this.tagsInUpdate = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";
@import '~@/styles/variables';

.user-portfolio-tags {
    display: flex;
    flex-direction: column;
    gap: mrem(16);

    @include on-desktop {
        gap: rem(16);
    }

    &__title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        color: $color-secondary-violet;
        font-weight: 600;
        font-size: mrem(16);
        line-height: mrem(32);

        @include on-desktop {
            font-size: rem(16);
            line-height: rem(32);
        }
    }

    &__history-button {
        cursor: pointer;
        color: $color-main-blue;
        display: flex;
        flex-direction: row;
        gap: mrem(6);

        @include on-desktop {
            gap: rem(6);
        }
    }

    &__history-button-icon {
        display: inline-block;
        padding-top: mrem(2);

        @include on-desktop {
            padding-top: rem(2);
        }
    }

    &__list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: mrem(16);

        @include on-desktop {
            gap: rem(16);
        }
    }
}
.user-portfolio-tags-available {
    display: flex;
    flex-direction: column;
    gap: mrem(8);


    @include on-desktop {
        gap: rem(8);
    }

    &__title {
        cursor: pointer;
        display: inline-flex;
        align-items: center;
        font-weight: 400;
        font-size: mrem(14);
        line-height: mrem(20);
        gap: mrem(4);

        @include on-desktop {
            font-size: rem(14);
            line-height: rem(20);
            gap: rem(4);
        }

        &:after {
            display: inline-block;
            content: '';
            width: mrem(24);
            height: mrem(24);
            background: url('~@/assets/images/portfolio/chevron.svg') no-repeat center center;
            background-size: cover;

            @include on-desktop {
                width: rem(24);
                height: rem(24);
            }
        }

        &--opened {
            &:after {
                transform: rotate(180deg);
            }
        }
    }

    &__list {
        border-top: mrem(1) solid $color-secondary-blue-light;
        padding-top: mrem(16);
        display: none;

        @include on-desktop {
            padding-top: rem(16);
            border-top-width: rem(1);
        }

        &--opened {
            display: flex;
        }
    }
}
</style>
